import { ProductGridImage } from '..';
import { ITooltip } from '../ToolTipsOverlay';

const generateToolTipsFromImage = (image: ProductGridImage): ITooltip[] => {
  const tooltips = [
    image.tooltip1_x !== null && image.tooltip1_y !== null
      ? {
          title: image.tooltip1_title,
          body: image?.tooltip1_body?.[0].text,
          position: {
            x: image.tooltip1_x,
            y: image.tooltip1_y,
          },
        }
      : [],
    image.tooltip2_x !== null && image.tooltip2_y !== null
      ? {
          title: image.tooltip2_title,
          body: image?.tooltip2_body?.[0].text,
          position: {
            x: image.tooltip2_x,
            y: image.tooltip2_y,
          },
        }
      : [],
    image.tooltip3_x !== null && image.tooltip3_y !== null
      ? {
          title: image.tooltip3_title,
          body: image?.tooltip3_body?.[0].text,
          position: {
            x: image.tooltip3_x,
            y: image.tooltip3_y,
          },
        }
      : [],
  ].flat();

  return tooltips;
};

export default generateToolTipsFromImage;
